import { render, staticRenderFns } from "./BrowseKyoai.vue?vue&type=template&id=2a3ab076&scoped=true&"
import script from "./BrowseKyoai.vue?vue&type=script&lang=js&"
export * from "./BrowseKyoai.vue?vue&type=script&lang=js&"
import style0 from "./BrowseKyoai.vue?vue&type=style&index=0&id=2a3ab076&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3ab076",
  null
  
)

export default component.exports